import React, { Component } from 'react';

// import Formsy from 'formsy-react';

import FormInput from '../../../components/common/elements/FormInput';
import TextareaWithLabel from '../../../components/common/elements/TextareaWithLabel';
import translator from '../../../components/localization/translator';
import { } from './balanceDetails';

export default class EditableField extends Component {

	constructor(props) {
		super(props);
		this.state = {
			input: '',
			comment: ''
		}
		this.renderInput = this.renderInput.bind(this);
	}

	renderInput(field) {
		const key = field.key;
		return(
			<FormInput
				key={key}
				htmlFor={key}
				label={field.title}
				id={key}
				name={key}
				value={this.state.input || ''}
                onChange={(e)=>{this.setState({input: e.target.value});
				this.props.setChangedData(key, e.target.value)}}/>
		);
	}

    renderComment() {
        return(
			<TextareaWithLabel
				label={translator.translate("_comment_")}
				id={"comment"}
				disabled={false}
				htmlFor={"comment"}
				name='comment'
				value={this.state.comment || ''}
				onChange={(e)=>{
					this.setState({comment: e.target.value});
					this.props.setChangedData("comment", e.target.value)}}>
			</TextareaWithLabel>
        )
    }

	render() {
		return (
			<div>
                {this.renderInput({
					key: "input",
					title: "_amount_"
				})}
                {this.renderComment()}
			</div>
		);
	}
}
